import styled from 'styled-components';

export const DivInputStyle = styled.div`
  position: relative;
  display: inline-flex;
  width: 100%;
  min-width: 0;
  color: rgba(0, 0, 0, 0.88);
  font-size: 14px;
  line-height: 1.5714285714285714;
  background-color: #ffffff;
  background-image: none;
  border-width: 1px;
  border-style: solid;
  border-color: #d9d9d9;
  transition: all 0.2s;
  padding: 7px 11px;
  font-size: 16px;
  line-height: 1.5;
  border-radius: 4px;
  max-height: 40px;
  overflow: hidden;
`;
